import { Preferences } from "../../profile/objects/preferences";
import { COMMERCIAL_MODULE, DEFAULT_COLUMN } from "../constant/commercialConstant";
import { Column } from "../objects/column";
import { setListPreference, ListPreferenceResult } from "../../utils/list/utils/setListPreference";

export const setCommercialPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: COMMERCIAL_MODULE,
        default_columns: DEFAULT_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });